export const CHART_COLORS = {
  gewonnen: '#3b82f6',
  ausstehend: '#f59e0b',
  anfragen: '#22c55e',
  umsatzPaid: '#3b82f6',
  umsatzOpen: '#cbd5e1',
} as const;

/** Category color slug (see leadCategoryColors) → chart hex. */
export const CATEGORY_HEX: Record<string, string> = {
  orange: '#f97316',
  blue: '#3b82f6',
  cyan: '#06b6d4',
  emerald: '#10b981',
  violet: '#8b5cf6',
  amber: '#f59e0b',
  teal: '#14b8a6',
  indigo: '#6366f1',
  slate: '#94a3b8',
};

export function categoryHex(color: string | null | undefined): string {
  const key = String(color ?? '').trim().toLowerCase();
  return CATEGORY_HEX[key] ?? CATEGORY_HEX.slate;
}

export function formatChartCount(value: number): string {
  return value.toLocaleString('de-DE');
}
